import type QuestionModel from '../../../models/QuestionModel';
import { requestAndParse, requestSuccessful } from '../request';

const getQuestions = async (searchTerm?: string) => {
    const route = 'admin/get-questions';
    const payload = { searchTerm };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const questions = (response.body?.questions ?? []) as QuestionModel[];

    return { success, questions };
};

export default getQuestions;
